// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"UR","selections":"VR","pillsDesktopSearchMenu":"WR"};